var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"ml-auto",attrs:{"text":""},on:{"click":_vm.clear_local_storage}},[_vm._v(" Колонки по умолчанию ")])
}
var staticRenderFns = []

export { render, staticRenderFns }